import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Container from './Container';
import { ItemStyle, ListStyle, DataProps, RenderItem } from './interface';
interface IProps extends DataProps, RenderItem, ItemStyle, ListStyle {
}

export default function Drop(props: IProps) {
 
  return (
    <DndProvider backend={HTML5Backend}>
      <Container
        {...props}
      />
    </DndProvider>
  );
}



// WEBPACK FOOTER //
// ./src/display/components/Drop/index.tsx